import { ExportControlLevel } from '@precheckin/models/export-control/export-control-level.enum';
import { cloneDeep } from 'lodash';
export interface IExportControlCountry {
  id: string;
  updatedAt: string;
  restrictionLevel: ExportControlLevel;
}
export class ExportControlCountry implements IExportControlCountry {
  id: string;
  updatedAt: string;
  restrictionLevel: ExportControlLevel;

  constructor(clone: ExportControlCountry = null) {
    this.id = '';
    this.updatedAt = '';
    this.restrictionLevel = null;
    if (clone) {
      this.id = cloneDeep(clone.id);
      this.restrictionLevel = cloneDeep(clone.restrictionLevel);
      this.updatedAt = cloneDeep(clone.updatedAt);
    }
  }
}
